import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { z } from "zod";
import { Tables } from "@/gen/tableNames/tables";
import { Clients } from "@/lib/clients";
import { dateSchema, parseToDateValue } from "@/features/FormCard/utils";
import { useTranslation } from "react-i18next";

const filterS1MonthlyCommentsSchema = z.object({
  strategy_id_equals: z.string().optional(),
  strategy_name_contains: z.string().optional(),
  comment_type_equals: z.string().optional(),
  date_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  date_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});
export type FilterS1MonthlyCommentsSchema = z.infer<
  typeof filterS1MonthlyCommentsSchema
>;

const filterS1MonthlyCommentsFields =
  filterS1MonthlyCommentsSchema.keyof().enum;

export function FilterS1MonthlyComments() {
  const { t, i18n } = useTranslation("tables");

  const fields: Field[] = [
    {
      name: filterS1MonthlyCommentsFields.strategy_id_equals,
      label: t(`${Tables.S1_MONTHLY_COMMENTS}.searchbox.strategy_id_equals`),
      type: "input",
    },
    {
      name: filterS1MonthlyCommentsFields.strategy_name_contains,
      label: t(`${Tables.S1_MONTHLY_COMMENTS}.searchbox.strategy_name_contains`),
      type: "input",
    },
    {
      name: filterS1MonthlyCommentsFields.comment_type_equals,
      label: t(`${Tables.S1_MONTHLY_COMMENTS}.searchbox.comment_type_equals`),
      type: "select",
      useTranslation: true,
      translate_key: "comment_type",
      client: Clients.S1_QUANTILIA,
      table_name: Tables.S1_MONTHLY_COMMENTS,
      language: i18n.resolvedLanguage?.startsWith("fr") ? "fr" : "en",
    },
    {
      name: "date",
      type: "dateRange",
      label: t(`${Tables.S1_MONTHLY_COMMENTS}.searchbox.date`),
      from: { name: filterS1MonthlyCommentsFields.date_from },
      to: { name: filterS1MonthlyCommentsFields.date_to },
      col_span: 2,
    },
  ];

  return (
    <FilterTable
      client={Clients.S1_QUANTILIA}
      schema={filterS1MonthlyCommentsSchema}
      tableName={`${Tables.S1_MONTHLY_COMMENTS}`}
      customBuildPath={() => `${Tables.S1_MONTHLY_COMMENTS}`}
      fields={fields}
    />
  );
}
